import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { SlideShowPage } from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import { APIEvent } from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import { ImgLoader } from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility,
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import * as PIXI from "pixi.js";

import { Apocalypse } from "../Apocalypse";

export class ApocalypseIntroConfig implements GameIntroViewConfig {
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0.4,
            bulletColor: 0xffffff,
        },
        stampColor: 0xffffff,
    };

    stampConfig: StampConfig = {
        xNudgeSuper: true,
        xNudge: true,
        xBet: true,
        volatility: Volatility.EXTREME,
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[] = [];

    constructor() {}

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(`introBg`, `resources/images/Intro_BG.jpg`);
        imgLoader.add(`introDiv1`, `resources/images/Intro_Divider_1.png`);
        imgLoader.add(`introDiv2`, `resources/images/Intro_Divider_2.png`);
        imgLoader.add(`page1`, `resources/images/page1.png`);
        imgLoader.add(`page2`, `resources/images/page2.png`);
        imgLoader.add(`page3`, `resources/images/page4.png`);
        imgLoader.add(`page4`, `resources/images/page3.png`);
        imgLoader.add(`page5`, `resources/images/page5.png`);
        imgLoader.add(`logo`, `resources/images/logo.png`);
        imgLoader.add(`maxWinAmount`, `resources/images/maxWinAmount.png`);

        return imgLoader.load().then(() => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        this.background.name = `IntroBackground`;
        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`introBg`));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderTop.name = `IntroBorderTop`;
        const topSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`introDiv1`));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        this.borderBottom.name = `IntroBorderBottom`;
        const bottomSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`introDiv2`));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        this.logo.name = `IntroLogoContainer`;

        const maxImg: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`maxWinAmount`));
        maxImg.name = `Logo50k`;
        maxImg.scale.set(0.22);
        maxImg.anchor.set(0.5, 0.5);
        maxImg.position.set(210, 6);
        maxImg.visible = false;
        this.logo.addChild(maxImg);

        const logoSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`logo`));
        logoSprite.name = `LogoImage`;
        logoSprite.scale.set(0.5);
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        for (let count: number = 1; count <= 4; count++) {
            let page = new SlideShowPage(ImgLoader.getImgTexture(`page` + count));
            page.name = `page${count}`;
            (page.children[0] as PIXI.Sprite).anchor.set(0.5);
            (page.children[0] as PIXI.Sprite).x = -5;
            this.pages.push(page);
        }

        if (Apocalypse.apiPlugin.gameClientConfiguration.isSet) {
            this.handleConditionalPages();
        } else {
            Apocalypse.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.handleConditionalPages();
            });
        }
    }

    private handleConditionalPages(): void {
        if (Apocalypse.apiPlugin.gameClientConfiguration.showSimulatedMaximumPayout) {
            this.addWinCapPage();

            this.logo.children[1].visible = true;
        } else {
            this.logo.children[1].visible = false;
        }
    }

    private addWinCapPage(): void {
        const page: SlideShowPage = new SlideShowPage();
        page.name = `page5`;

        const winCapImage: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`page5`));
        winCapImage.anchor.set(0.5);
        winCapImage.x = -5;
        page.addChild(winCapImage);
        this.pages.push(page);
    }
}
